module.exports = __webpack_public_path__ + "img/Kuwait-landscape-arabic.c58ddfd4.jpg";